module.exports = __webpack_public_path__ + "static/media/hollow_bar_prewash_tall.b87c6334.svg";